import type { AccountController, RpcClient } from "@hq/client";
import { createContext, useContext } from "react";

export type AppConfig = {
  bootMs?: number;
  hasServer: boolean;
  account?: AccountController;
  rpc?: RpcClient;
  onResetLocalData?: () => Promise<void>;
  onReauthenticate?: () => Promise<void>;
  onReady?: () => void;
};

export const AppConfigContext = createContext<AppConfig>({ hasServer: false });

export function useAppConfig(): AppConfig {
  return useContext(AppConfigContext);
}
